module.exports = __webpack_public_path__ + "static/media/logo.49a72a0a.svg";